const observations = [
  'Maggiore capacità di descrivere le sfumature di ciò che accade.',
  'Persistenza di tensione nei contesti di lavoro.',
] as const;

type Stat = { value: number; label: string };

// Mockup marketing: riepilogo settimanale che lo psicologo trova in dashboard.
export function WeeklySummaryCard({
  stats,
  themes,
}: {
  stats?: readonly Stat[];
  themes: readonly string[];
}) {
  return (
    <>
      <div className="flex flex-wrap items-center justify-between gap-2 border-b border-border px-6 py-4">
        <p className="font-bold text-primary-dark">Riepilogo settimanale</p>
        <span className="text-xs text-muted-foreground">8 – 14 giugno 2026</span>
      </div>
      <div className="grid gap-5 p-6">
        {stats ? (
          <div className="grid grid-cols-3 gap-3">
            {stats.map((stat) => (
              <div key={stat.label} className="rounded bg-blue-lighter px-4 py-3">
                <p className="text-2xl font-bold text-primary">{stat.value}</p>
                <p className="text-xs text-gray-darker">{stat.label}</p>
              </div>
            ))}
          </div>
        ) : null}

        <div>
          <p className="mb-2.5 font-accent text-xs uppercase tracking-wide text-muted-foreground">
            Temi ricorrenti
          </p>
          <div className="flex flex-wrap gap-2">
            {themes.map((theme) => (
              <span
                key={theme}
                className="rounded-full bg-secondary px-3 py-1 text-xs font-semibold text-orange-dark"
              >
                {theme}
              </span>
            ))}
          </div>
        </div>

        <div>
          <p className="mb-2.5 font-accent text-xs uppercase tracking-wide text-muted-foreground">
            Osservazioni
          </p>
          <div className="grid gap-2 text-sm text-gray-darker">
            {observations.map((observation) => (
              <div key={observation} className="flex gap-2.5">
                <span aria-hidden className="font-bold text-primary">
                  ·
                </span>
                {observation}
              </div>
            ))}
          </div>
        </div>

        <div className="rounded border border-border border-l-4 border-l-primary px-4 py-3.5">
          <div className="mb-1 flex items-center justify-between gap-3">
            <p className="text-xs font-bold text-primary-dark">Evento chiave · 9 giugno</p>
            <span className="text-xs font-semibold text-primary">Dati grezzi</span>
          </div>
          <p className="text-sm text-gray-darker">
            Riunione evitata dopo una notte quasi insonne. Evidenzia il legame tra anticipazione del
            giudizio e sonno.
          </p>
        </div>

        <p className="text-xs text-muted-foreground">Esempio illustrativo con dati non reali.</p>
      </div>
    </>
  );
}
